const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function fetchBlogMeta() {
  try {
    const res = await fetch(`${API}/blog/meta`);
    if (!res.ok) return {};
    const list = await res.json();
    return Object.fromEntries(list.map((m) => [m.slug, m]));
  } catch {
    return {};
  }
}

export async function registerView(slug) {
  try {
    const res = await fetch(`${API}/blog/${slug}/view`, { method: "POST" });
    return res.ok ? res.json() : null;
  } catch {
    return null;
  }
}

export async function fetchComments(slug) {
  try {
    const res = await fetch(`${API}/blog/${slug}/comments`);
    return res.ok ? res.json() : [];
  } catch {
    return [];
  }
}

export async function postComment(slug, name, text) {
  const res = await fetch(`${API}/blog/${slug}/comments`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, text }),
  });
  if (!res.ok) throw new Error("Failed to post comment");
  return res.json();
}

const withCreds = { credentials: "include" };

export async function fetchAdminComments() {
  const res = await fetch(`${API}/admin/comments`, withCreds);
  if (!res.ok) throw new Error("Failed to load comments");
  return res.json();
}

export async function approveComment(id) {
  const res = await fetch(`${API}/admin/comments/${id}/approve`, { method: "POST", ...withCreds });
  if (!res.ok) throw new Error("Failed to approve comment");
  return res.json();
}

export async function deleteComment(id) {
  const res = await fetch(`${API}/admin/comments/${id}`, { method: "DELETE", ...withCreds });
  if (!res.ok) throw new Error("Failed to delete comment");
  return res.json();
}
